import React from "react";
import BG from "../assets/images/wallpaper/home-bg.jpg";

function About() {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-96"
        style={{
          backgroundImage: `url(${BG})`, // Replace with the actual path of your image
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 flex items-center justify-center h-full">
          <h1 className="text-4xl sm:text-5xl font-bold text-white">About Us</h1>
        </div>
      </section>

      {/* Company Profile Section */}
      <section className="container mx-auto px-6 py-12">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-gray-800 text-center">
          Company Profile
        </h2>
        <div className="border-t-2 border-yellow-500 w-24 mx-auto mb-8"></div>

        {/* Profile Details */}
        <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
          <p>
            <span className="font-bold">Company Name:</span> Materials Index
          </p>
          <p>
            <span className="font-bold">Business Type:</span> All Kinds of Machineries Indenting Firm
          </p>
          <p>
            <span className="font-bold">Year of Establishment:</span> 2019
          </p>
          <p>
            <span className="font-bold">Products:</span> Garments Printing
            Materials & Machine, Textile Label Printing Materials & Machine,
            Heat Transfer Printing Materials & Machine, Printing – Packaging
            Materials & Machine, Digital Printing Materials & Machine.
          </p>
          <p>
            <span className="font-bold">Application Industry:</span> Garments,
            Textile & Printing Firm.
          </p>
          <p>
            <span className="font-bold">No of Employees:</span> 35.
          </p>
          <p>
            <span className="font-bold">Office Address:</span> House 75, Block B, Road #1, Niketon,
            Dhaka-1212
          </p>
        </div>
      </section>
    </div>
  );
}

export default About;
